import React from 'react';

interface UpcomingEventsCardProps {
  events: any[];
}

const UpcomingEventsCard: React.FC<UpcomingEventsCardProps> = ({ events }) => {
  const formatDate = (dateString: string | number | Date): string => {
  const date = new Date(dateString);
  
  const formatter = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  });

  const parts = formatter.formatToParts(date);
  
  const year = parts.find(p => p.type === 'year')?.value;
  const month = parts.find(p => p.type === 'month')?.value;
  const day = parts.find(p => p.type === 'day')?.value;

  return `${year}-${month}-${day}`;
};
  return (
    <section className="card" aria-labelledby="upcoming-events">
      <h3 id="upcoming-events">Upcoming Events</h3>
      <ul>
        {events.length > 0 ? (
          events.map((event, index) => (
            <>
            <li key={index}><a style={{color: '#fff', textDecoration: 'underline'}} href={`/event/${event.eventcode}`}>{event.name}</a> | <span>{formatDate(new Date(event.startdate))}</span></li>
            </>
          ))
        ) : (
          <>
            <li>Stay tuned for upcoming events</li>
          </>
        )}
      </ul>
     {/* <button className="btn-default" aria-label="Learn more about upcoming events">Learn More</button>*/}
    </section>
  );
};


export default UpcomingEventsCard;